"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicDeliveryOption = exports.getPublicDeliveryOptions = exports.putDeliveryOptionAccessibility = exports.deleteDeliveryOptionPermission = exports.postDeliveryOptionPermission = exports.postDeliveryOption = exports.putDeliveryOption = exports.getDeliveryOption = exports.getDeliveryOptions = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var deliveryOptionsAuthorizedPath = root_1.ecommerceAuthorized + '/deliveryoptions/';
var deliveryOptionsPublicPath = root_1.ecommercePublic + '/deliveryoptions/';

var getDeliveryOptions = function getDeliveryOptions(authentication, queryParameters) {
  return common_1.get(authentication, deliveryOptionsAuthorizedPath, queryParameters);
};

exports.getDeliveryOptions = getDeliveryOptions;

var getDeliveryOption = function getDeliveryOption(authentication, id) {
  return common_1.get(authentication, deliveryOptionsAuthorizedPath + id);
};

exports.getDeliveryOption = getDeliveryOption;

var putDeliveryOption = function putDeliveryOption(authentication, deliveryoption) {
  return common_1.put(authentication, deliveryOptionsAuthorizedPath + deliveryoption.id, deliveryoption);
};

exports.putDeliveryOption = putDeliveryOption;

var postDeliveryOption = function postDeliveryOption(authentication, deliveryoption) {
  return common_1.post(authentication, deliveryOptionsAuthorizedPath, deliveryoption);
};

exports.postDeliveryOption = postDeliveryOption;

var postDeliveryOptionPermission = function postDeliveryOptionPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, deliveryOptionsAuthorizedPath, id, permission);
};

exports.postDeliveryOptionPermission = postDeliveryOptionPermission;

var deleteDeliveryOptionPermission = function deleteDeliveryOptionPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, deliveryOptionsAuthorizedPath, id, permissionId);
};

exports.deleteDeliveryOptionPermission = deleteDeliveryOptionPermission;

var putDeliveryOptionAccessibility = function putDeliveryOptionAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, deliveryOptionsAuthorizedPath, id, accessibility);
};

exports.putDeliveryOptionAccessibility = putDeliveryOptionAccessibility;

var getPublicDeliveryOptions = function getPublicDeliveryOptions(authentication, queryParameters) {
  return common_1.get(authentication, deliveryOptionsPublicPath, queryParameters);
};

exports.getPublicDeliveryOptions = getPublicDeliveryOptions;

var getPublicDeliveryOption = function getPublicDeliveryOption(authentication, id) {
  return common_1.get(authentication, deliveryOptionsPublicPath + id);
};

exports.getPublicDeliveryOption = getPublicDeliveryOption;